import { Customer } from "types/customer"

export const byField =
  (field: keyof Customer) =>
  ({ [field]: v1 }: Customer, { [field]: v2 }: Customer): number =>
    (v1 ?? 0) < (v2 ?? 0) ? -1 : 1
